<template>
	<div>
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
				<v-tabs v-model="tabOpen" centered grow>
					<v-tab href="#suppliers">
						<v-icon left>store</v-icon>
						<translate>Suppliers</translate>
					</v-tab>
					<v-tab href="#product_units">
						<v-icon left>mdi-google-circles-communities</v-icon>
						<translate>Units</translate>
					</v-tab>
					<v-tab href="#substance_types">
						<v-icon left>mdi-spa</v-icon>
						<translate>Substance Types</translate>
					</v-tab>
					<v-tab href="#plant_parts">
						<v-icon left>mdi-sprout</v-icon>
						<translate>Plant Parts</translate>
					</v-tab>
					<v-tab href="#product_storages">
						<v-icon left>mdi-bottle-tonic-plus</v-icon>
						<translate>Storages</translate>
					</v-tab>
					<v-tab href="#product_presentations">
						<v-icon left>mdi-pill</v-icon>
						<translate>Presentations</translate>
					</v-tab>
					<v-tab href="#product_processing">
						<v-icon left>mdi-cached</v-icon>
						<translate>Processing</translate>
					</v-tab>
					<v-tab href="#medicine_interactions">
						<v-icon left>mdi-pill</v-icon>
						<translate>Drug Interactions</translate>
					</v-tab>
				</v-tabs>
				<v-tabs-items v-model="tabOpen" class="mt-2">
					<v-tab-item value="suppliers">
						<Suppliers :suppliers="suppliers" />
					</v-tab-item>
					<v-tab-item value="product_units">
						<ProductPropertyManager type="product_units" :items="product_units" />
					</v-tab-item>
					<v-tab-item value="substance_types">
						<ProductPropertyManager type="substance_types" :items="substanceTypes" />
					</v-tab-item>
					<v-tab-item value="plant_parts">
						<ProductPropertyManager type="plant_parts" :items="plantParts" />
					</v-tab-item>
					<v-tab-item value="product_storages">
						<ProductPropertyManager type="product_storages" :items="productStorages" />
					</v-tab-item>
					<v-tab-item value="product_presentations">
						<ProductPropertyManager type="product_presentations" :items="productPresentations" />
					</v-tab-item>
					<v-tab-item value="product_processing">
						<ProductPropertyManager type="product_processing" :items="productProcessing" />
					</v-tab-item>
					<v-tab-item value="medicine_interactions">
						<p key="medicine_interaction_categories" class="title"><translate>Drug Interaction Category</translate></p>
						<ProductPropertyManager type="medicine_interaction_categories" :items="medicineInteractionCategories" />
						<p key="medicine_interactions" class="mt-2 title"><translate>Drug Interaction</translate></p>
						<ProductPropertyManager type="medicine_interactions" :items="medicineInteractions" :medicineInteractionCategories="medicineInteractionCategories" />
					</v-tab-item>
				</v-tabs-items>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import Suppliers from "@/components/admin/Suppliers.vue";
import ProductPropertyManager from "@/components/admin/ProductPropertyManager.vue";
import NavBar from "@/components/authentication/NavBar.vue";
import axios from "axios";

export default {
	name: "ProductProperties",
	components: {
		NavBar,
		Suppliers,
		ProductPropertyManager
	},
	data: () => ({
		tabOpen: "suppliers",
		suppliers: [],
		product_units: [],
		substanceTypes: [],
		plantParts: [],
		productStorages: [],
		productPresentations: [],
		productProcessing: [],
		medicineInteractions: [],
		medicineInteractionCategories: []
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Product Properties"),
					disabled: true,
					link: true
				}
			];
		}
	},
	created() {
		axios
			.get("/admin/product-properties")
			.then(response => {
				console.log(response.data);
				this.suppliers = response.data.providers;
				this.product_units = response.data.product_units;
				this.substanceTypes = response.data.substance_types;
				this.plantParts = response.data.plant_parts;
				this.productStorages = response.data.product_storages;
				this.productPresentations = response.data.product_presentations;
				this.productProcessing = response.data.product_processing;
				this.medicineInteractions = response.data.medicine_interactions;
				this.medicineInteractionCategories = response.data.medicine_interaction_categories;
			})
			.catch(error => console.log(error));
	}
};
</script>